export const joinClassNames = (...classNames: (string | undefined | null)[]) =>
  classNames.filter((_) => _).join(" ");
